/**
 * @desc MongoDB操作数据-获取
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.SaveFiledDto>>;
export function request(body: defs.basics.TaskGetDataRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/task/api/get/mdbData`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
